






























































































import gql from 'graphql-tag';
import { get, filter } from 'lodash';
import { format } from 'date-fns';
import { mapActions, mapGetters } from 'vuex';
import { BDropdown, BDropdownItemButton, BDropdownDivider } from 'bootstrap-vue';
import LoadingSpinner from '@reciprocity/loading-spinner';
import ZenButton from '@reciprocity/button';
import { userRoleCanEdit } from '@/utils/DashboardUtils';

export const DASHBOARD_LIST_QUERY = gql`
  query DashboardList {
    search(type: Dashboard) {
      edges {
        node {
          nodeId: id
          ... on Dashboard {
            id
            title {
              value
            }
            owners {
              value {
                edges {
                  node {
                    ... on Person {
                      id
                      name {
                        value
                      }
                      userRole {
                        value
                      }
                    }
                  }
                }
              }
            }
            updatedAt {
              value
            }
          }
        }
      }
    }
  }
`;

const DELETE_DASHBOARD_MUTATION = gql`
  mutation DeleteDashboardMutation($id: ID!) {
    result: deleteDashboard(id: $id) {
      removed
    }
  }
`;

export default {
  name: 'DashboardListPage',
  components: {
    ZenButton,
    LoadingSpinner,
    BDropdown,
    BDropdownItemButton,
    BDropdownDivider,
  },
  apollo: {
    dashboards: {
      query: DASHBOARD_LIST_QUERY,
      update(result) {
        return result.search.edges.map(edge => {
          const edgeNamePath = '0.node.name.value';
          const owners = get(edge, 'node.owners.value.edges', []);
          const admins = filter(owners, owner => owner.node.userRole.value === 'Administrator');

          const owner = admins.length ? get(admins, edgeNamePath) : get(owners, edgeNamePath);

          return {
            id: get(edge, 'node.id'),
            nodeId: get(edge, 'node.nodeId'),
            title: get(edge, 'node.title.value'),
            owner,
            updatedAt: get(edge, 'node.updatedAt.value'),
          };
        });
      },
    },
    userRole: {
      query: gql`
        query GetUserRole {
          currentUser {
            userRole {
              value
            }
          }
        }
      `,
      update(result) {
        return get(result, 'currentUser.userRole.value');
      },
    },
  },
  data() {
    return {
      dashboards: [],
      userRole: null,
    };
  },
  computed: {
    ...mapGetters(['featureFlags']),
    canEdit() {
      return userRoleCanEdit(this.userRole);
    },
  },
  created() {
    this.setPageTitle({ title: 'Dashboard List', visible: false });
  },
  methods: {
    ...mapActions(['setPageTitle']),
    ...mapActions({
      showModal: 'modals/show',
      showAlert: 'alerts/show',
    }),
    onCreateNewDashboard() {
      this.$router.push('/dashboards/new');
    },
    async onEditDashboard(dashboard) {
      const updatedDashboard = await this.showModal({
        type: 'DashboardCard',
        data: {
          cardTitle: 'Edit Dashboard',
          dashboard,
        },
      });

      const title = get(updatedDashboard, 'title.value');
      const updatedAt = get(updatedDashboard, 'updatedAt.value');

      dashboard.title = title;
      dashboard.updatedAt = updatedAt;
    },
    async onDeleteDashboard(dashboard) {
      try {
        await this.showModal({
          type: 'DashboardDeleteCard',
          data: {
            dashboardElement: dashboard.title,
          },
        });

        // optimistically removing element from the list
        const dashboardIndex = this.dashboards.indexOf(dashboard);
        this.dashboards.splice(dashboardIndex, 1);

        try {
          await this.$apollo.mutate({
            mutation: DELETE_DASHBOARD_MUTATION,
            variables: {
              id: dashboard.id,
            },
            refetchQueries: [{ query: DASHBOARD_LIST_QUERY }],
          });
        } catch (e) {
          // adding element back if request fails
          this.dashboards.splice(dashboardIndex, 0, dashboard);

          this.showAlert({
            type: 'error',
            message: `Failed removing "${dashboard.title}"`,
          });
        }
      } catch (e) {
        // Modal canceled
      }
    },
    async onShareDashboard(dashboard) {
      try {
        await this.showModal({
          type: 'ShareDashboardCard',
          data: {
            dashboardTitle: dashboard.title,
            dashboardId: dashboard.id,
          },
        });
      } catch (e) {
        // User closed modal
      }
      this.$apollo.queries.dashboards.refetch();
    },
    formatDate(date) {
      return format(new Date(date), 'd/MMM/yyyy h:mm a');
    },
  },
};
